"use client";

import { useActionState } from "react";
import { loginAction, type LoginState } from "@/app/actions/auth";

export default function LoginPage() {
  const [state, formAction, pending] = useActionState(loginAction, null as LoginState);

  return (
    <div className="flex h-full flex-1 items-center justify-center overflow-y-auto bg-canvas px-4 py-16">
      <div className="admin-card-elevated w-full max-w-sm p-8">
        <div className="mx-auto flex size-11 items-center justify-center rounded-xl bg-brand text-lg font-bold text-white">
          A
        </div>
        <h1 className="mt-4 text-center text-lg font-semibold text-zinc-900">Market admin</h1>
        <p className="mt-1 text-center text-sm text-zinc-500">Sign in with credentials from your environment.</p>
        <form action={formAction} className="mt-6 space-y-4">
          <div>
            <label htmlFor="username" className="block text-xs font-medium text-zinc-700">
              Username
            </label>
            <input
              id="username"
              name="username"
              type="text"
              autoComplete="username"
              required
              className="input-field mt-1"
            />
          </div>
          <div>
            <label htmlFor="password" className="block text-xs font-medium text-zinc-700">
              Password
            </label>
            <input
              id="password"
              name="password"
              type="password"
              autoComplete="current-password"
              required
              className="input-field mt-1"
            />
          </div>
          {state?.error ? (
            <p className="text-sm text-red-600" role="alert">
              {state.error}
            </p>
          ) : null}
          <button type="submit" disabled={pending} className="btn-primary w-full py-2.5">
            {pending ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
